import { render, staticRenderFns } from "./widget_waiting_values.vue?vue&type=template&id=21e49464&scoped=true&"
import script from "./widget_waiting_values.vue?vue&type=script&lang=js&"
export * from "./widget_waiting_values.vue?vue&type=script&lang=js&"
import style0 from "./widget_waiting_values.vue?vue&type=style&index=0&id=21e49464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e49464",
  null
  
)

export default component.exports